/**
* 字典
*/

// 登录类型
export const loginTypes = {
  normal: 'normal', // 正常登录
  force: 'force', // 强制登录
  silent: 'silent', // 静默登录
  tokenExpire: 'tokenexpire', // 刷新token
  tokenError: 'tokenerror', // token错误
}

// 账户类型
export const accountTypes = {
  none: 'none', // 不开户
  acc: 'acc', // 基础账户
  custody: 'custody', // 存管账户
  cardbull: 'cardbull', // 卡牛信用卡还款账户
}


export default {
  loginTypes,
  accountTypes,
}
